import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { PackSection } from './components/PackSection';
import { PricingSection } from './components/PricingSection';
import { ClosingSection } from './components/ClosingSection';
import { FaqSection } from './components/FaqSection';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="31agp2qt1ejki">
      <OfferBar data-id="element-1" data-mp="31ctbbg5tvg3d" />
      <main data-id="element-2" data-mp="2wk0av4he6tx3">
        <Hero data-id="element-3" data-mp="2wjgrdjc3fxgy" />
        <PainSection data-id="element-4" data-mp="2wjqkvgwckmre" />
        <ProductSection data-id="element-5" data-mp="2wiffxdr618yp" />
        <BonusSection data-id="element-6" data-mp="2wi5n7ieqknpb" />
        <PackSection data-id="element-7" data-mp="28u5zysgmvffh" />
        <PricingSection data-id="element-8" data-mp="28tmifcuwat1z" />
        <ClosingSection data-id="element-9" data-mp="28suveqfd63nb" />
        <FaqSection data-id="element-10" data-mp="28s2xh8yanttv" />
      </main>
      <SiteFooter data-id="element-11" data-mp="23vul23bheeqe" />
    </div>;
}